module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Black.b1abb878.otf";